webpackJsonp([51,49],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(174);
	module.exports = __webpack_require__(474);


/***/ }),

/***/ 420:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App'
	};

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var pageSize = 10;
	var cycleTime = [{ 'value': 1, 'label': '00:00 AM' }, { 'value': 2, 'label': '01:00 AM' }, { 'value': 3, 'label': '02:00 AM' }, { 'value': 4, 'label': '03:00 AM' }, { 'value': 5, 'label': '04:00 AM' }, { 'value': 6, 'label': '05:00 AM' }, { 'value': 7, 'label': '06:00 AM' }, { 'value': 8, 'label': '07:00 AM' }, { 'value': 9, 'label': '08:00 AM' }, { 'value': 10, 'label': '09:00 AM' }, { 'value': 11, 'label': '10:00 AM' }, { 'value': 12, 'label': '11:00 AM' }, { 'value': 13, 'label': '12:00 PM' }, { 'value': 14, 'label': '01:00 PM' }, { 'value': 15, 'label': '02:00 PM' }, { 'value': 16, 'label': '03:00 PM' }, { 'value': 17, 'label': '04:00 PM' }, { 'value': 18, 'label': '05:00 PM' }, { 'value': 19, 'label': '06:00 PM' }, { 'value': 20, 'label': '07:00 PM' }, { 'value': 21, 'label': '08:00 PM' }, { 'value': 22, 'label': '09:00 PM' }, { 'value': 23, 'label': '10:00 PM' }, { 'value': 24, 'label': '11:00 PM' }];
	
	exports.default = {
	  pageSize: pageSize,
	  cycleTime: cycleTime
	};

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		LStorage: {
			getItem: function getItem(key) {
				try {
					return JSON.parse(window.localStorage.getItem(key));
				} catch (err) {
					return null;
				}
			},
			setItem: function setItem(key, val) {
				window.localStorage.setItem(key, (0, _stringify2.default)(val));
			},
			clear: function clear() {
				window.localStorage.clear();
			},
			keys: function keys() {
				return window.localStorage.keys();
			},
			removeItem: function removeItem(key) {
				window.localStorage.removeItem(key);
			}
		},
		SStorage: {
			getItem: function getItem(key) {
				try {
					return JSON.parse(window.sessionStorage.getItem(key));
				} catch (err) {
					return null;
				}
			},
			setItem: function setItem(key, val) {
				window.sessionStorage.setItem(key, (0, _stringify2.default)(val));
			},
			clear: function clear() {
				window.sessionStorage.clear();
			},
			keys: function keys() {
				return window.sessionStorage.keys();
			},
			removeItem: function removeItem(key) {
				window.sessionStorage.removeItem(key);
			}
		},
		base64ToData: function base64ToData(apiData) {
			var base_to_json = Base64.decode(apiData);
			return base_to_json;
		},
	
		DataToBase64: function DataToBase64(apiParm) {
			var par_to_base = Base64.encode(apiParm);
			return par_to_base;
		},
		isPhone: function isPhone(inputVal) {
			var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
			if (!myreg.test(inputVal)) {
				return false;
			} else {
				return true;
			}
		},
		sortStr: function sortStr(str) {
			var upper = { "a": "A", "b": "B", "c": "C", "d": "D", "e": "E", "f": "F", "g": "G", "h": "H",
				"i": "I", "j": "J", "k": "K", "l": "L", "m": "M", "n": "N", "o": "O", "p": "P", "q": "Q",
				"r": "R", "s": "S", "t": "T", "u": "U", "v": "V", "w": "W", "x": "X", "y": "Y", "z": "Z" };
			for (var i in str) {
				for (var j in upper) {
					if (str[i] === upper[j]) {
						if (str != 'weeklyAverage') {
							str = str.replace(str[i], '_' + j);
						}
					}
				}
			}
			return str;
		},
		getTimeArea: function getTimeArea() {
			return new Date().getTimezoneOffset() / 60;
		},
		formatCycleTime: function formatCycleTime(timeName) {
			if (timeName == '00:00') timeName = '00:00 AM';
			if (timeName == '01:00') timeName = '01:00 AM';
			if (timeName == '02:00') timeName = '02:00 AM';
			if (timeName == '03:00') timeName = '03:00 AM';
			if (timeName == '04:00') timeName = '04:00 AM';
			if (timeName == '05:00') timeName = '05:00 AM';
			if (timeName == '06:00') timeName = '06:00 AM';
			if (timeName == '07:00') timeName = '07:00 AM';
			if (timeName == '08:00') timeName = '08:00 AM';
			if (timeName == '09:00') timeName = '09:00 AM';
			if (timeName == '10:00') timeName = '10:00 AM';
			if (timeName == '11:00') timeName = '11:00 AM';
			if (timeName == '12:00') timeName = '12:00 PM';
			if (timeName == '13:00') timeName = '01:00 PM';
			if (timeName == '14:00') timeName = '02:00 PM';
			if (timeName == '15:00') timeName = '03:00 PM';
			if (timeName == '16:00') timeName = '04:00 PM';
			if (timeName == '17:00') timeName = '05:00 PM';
			if (timeName == '18:00') timeName = '06:00 PM';
			if (timeName == '19:00') timeName = '07:00 PM';
			if (timeName == '20:00') timeName = '08:00 PM';
			if (timeName == '21:00') timeName = '09:00 PM';
			if (timeName == '22:00') timeName = '10:00 PM';
			if (timeName == '23:00') timeName = '11:00 PM';
			return timeName;
		},
		toDecimal: function toDecimal(x) {
			var f = parseFloat(x);
			if (isNaN(f)) {
				return false;
			}
			var f = Math.round(x * 100) / 100;
			var s = f.toString();
			var rs = s.indexOf('.');
			if (rs < 0) {
				rs = s.length;
				s += '.';
			}
			while (s.length <= rs + 2) {
				s += '0';
			}
			return s;
		},
		getDifference: function getDifference() {
			var difference = 0;
	
			var userInfo = JSON.parse(window.localStorage.getItem("userInfo")).store;
			if (userInfo) {
				difference = userInfo.difference;
			} else {
				difference = 0;
			}
			return difference;
		}
	};

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Print = function Print(dom, options) {
	  if (!(this instanceof Print)) return new Print(dom, options);
	
	  this.options = this.extend({
	    'noPrint': '.no-print'
	  }, options);
	
	  if (typeof dom === "string") {
	    this.dom = document.querySelector(dom);
	  } else {
	    this.isDOM(dom);
	    this.dom = this.isDOM(dom) ? dom : dom.$el;
	  }
	
	  this.init();
	};
	Print.prototype = {
	  init: function init() {
	    var content = this.getStyle() + this.getHtml();
	    this.writeIframe(content);
	  },
	  extend: function extend(obj, obj2) {
	    for (var k in obj2) {
	      obj[k] = obj2[k];
	    }
	    return obj;
	  },
	
	  getStyle: function getStyle() {
	    var str = "",
	        styles = document.querySelectorAll('style,link');
	    for (var i = 0; i < styles.length; i++) {
	      str += styles[i].outerHTML;
	    }
	    str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";
	
	    return str;
	  },
	
	  getHtml: function getHtml() {
	    var inputs = document.querySelectorAll('input');
	    var textareas = document.querySelectorAll('textarea');
	    var selects = document.querySelectorAll('select');
	
	    for (var k = 0; k < inputs.length; k++) {
	      if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
	        if (inputs[k].checked == true) {
	          inputs[k].setAttribute('checked', "checked");
	        } else {
	          inputs[k].removeAttribute('checked');
	        }
	      } else if (inputs[k].type == "text") {
	        inputs[k].setAttribute('value', inputs[k].value);
	      } else {
	        inputs[k].setAttribute('value', inputs[k].value);
	      }
	    }
	
	    for (var k2 = 0; k2 < textareas.length; k2++) {
	      if (textareas[k2].type == 'textarea') {
	        textareas[k2].innerHTML = textareas[k2].value;
	      }
	    }
	
	    for (var k3 = 0; k3 < selects.length; k3++) {
	      if (selects[k3].type == 'select-one') {
	        var child = selects[k3].children;
	        for (var i in child) {
	          if (child[i].tagName == 'OPTION') {
	            if (child[i].selected == true) {
	              child[i].setAttribute('selected', "selected");
	            } else {
	              child[i].removeAttribute('selected');
	            }
	          }
	        }
	      }
	    }
	
	    return this.dom.outerHTML;
	  },
	
	  writeIframe: function writeIframe(content) {
	    var w,
	        doc,
	        iframe = document.createElement('iframe'),
	        f = document.body.appendChild(iframe);
	    iframe.id = "myIframe";
	
	    iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
	    w = f.contentWindow || f.contentDocument;
	    doc = f.contentDocument || f.contentWindow.document;
	    doc.open();
	    doc.write(content);
	    doc.close();
	    var _this = this;
	    setTimeout(function () {
	      _this.toPrint(w);
	      setTimeout(function () {
	        document.body.removeChild(iframe);
	      }, 100);
	    }, 1000);
	  },
	
	  toPrint: function toPrint(frameWindow) {
	    try {
	      setTimeout(function () {
	        frameWindow.focus();
	        try {
	          if (!frameWindow.document.execCommand('print', false, null)) {
	            frameWindow.print();
	          }
	        } catch (e) {
	          frameWindow.print();
	        }
	        frameWindow.close();
	      }, 10);
	    } catch (err) {
	      console.log('err', err);
	    }
	  },
	  isDOM: (typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object' ? function (obj) {
	    return obj instanceof HTMLElement;
	  } : function (obj) {
	    return obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
	  }
	};
	var MyPlugin = {};
	MyPlugin.install = function (Vue, options) {
	  Vue.prototype.$print = Print;
	};
	exports.default = MyPlugin;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(175);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(113);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(475);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(892);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(174);
	
	var _axios = __webpack_require__(403);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(476);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _elementUi = __webpack_require__(791);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(809);
	
	__webpack_require__(879);
	
	__webpack_require__(878);
	
	var _common = __webpack_require__(471);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _print = __webpack_require__(472);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _Global = __webpack_require__(940);
	
	var _Global2 = _interopRequireDefault(_Global);
	
	var _en = __webpack_require__(794);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	_vue2.default.use(_print2.default);
	
	_vue2.default.prototype.GLOBAL = _Global2.default;
	_vue2.default.prototype.common = _common2.default;
	_vue2.default.prototype.moment = _moment2.default;
	_vue2.default.prototype.$axios = _axios2.default;
	
	_axios2.default.defaults.baseURL = ("/PPMS_API");
	
	_axios2.default.interceptors.request.use(function (config) {
	  if (config.method == 'get') {
	    config.params = (0, _extends3.default)({
	      _t: Date.parse(new Date()) / 1000
	    }, config.params);
	  }
	
	  var USER_TOKEN = localStorage.getItem('token') ? localStorage.getItem('token').replace(/\"/g, "") : null;
	
	  if (USER_TOKEN && !config.url.includes('login')) {
	    config.headers.common['token'] = USER_TOKEN;
	  }
	  return config;
	}, function (err) {
	  return _promise2.default.reject(err);
	});
	
	_axios2.default.interceptors.response.use(function (response) {
	  var nowIndex = window.location.pathname;
	  if (nowIndex != '/' && (response.data.code == -1000 || response.data.msg == 'Session Expired! Please log in again!')) {
	    setTimeout(function () {
	      VueInstance.$router.push('/');
	    }, 2000);
	  }
	  return response;
	}, function (error) {
	  console.log('error', error);
	  if (error.response) {
	    switch (error.response.code) {
	      case -1000:
	        _router2.default.replace({
	          path: '/',
	          query: { redirect: _router2.default.currentRoute.fullPath }
	        });
	    }
	  }
	  return _promise2.default.reject(error.response.data);
	});
	
	var VueInstance = new _vue2.default({
	  el: '#app',
	  router: _router2.default,
	  store: _index2.default,
	
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(992);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		mode: 'history',
		routes: [{
			path: '/',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(941)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
			}
		}, {
			path: '/tscg_system',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(933)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
			},
			redirect: '/tscg_system/Index',
			children: [{
				path: '/error404',
				name: 'Error404',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(894)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'Index',
				name: 'Index',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(893)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'balanceOnHand',
				name: 'balanceOnHand',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(926)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productForecast',
				name: 'productForecast',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(929)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'salesData',
				name: 'salesData',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(931)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemDisplayOrder',
				name: 'itemDisplayOrder',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(928)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'balanceOnHandByTime',
				name: 'balanceOnHandByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(927)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productForecastByTime',
				name: 'productForecastByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(930)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'salesDataByTime',
				name: 'salesDataByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(932)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'store',
				name: 'storeList',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(925)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'newStore',
				name: 'newStore',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(378)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'editStore',
				name: 'editStore',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(378)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'department',
				name: 'department',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(923)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'cluster',
				name: 'cluster',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(922)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'region',
				name: 'region',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(924)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'product',
				name: 'product',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(902)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productAdd',
				name: 'productAdd',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(903)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productEdit',
				name: 'productEdit',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(904)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'commodity',
				name: 'commodity',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(895)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'commodityAdd',
				name: 'commodityAdd',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(896)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'commodityEdit',
				name: 'commodityEdit',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(897)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productStandard',
				name: 'productStandard',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(907)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'percentageAdjust',
				name: 'percentageAdjust',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(901)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'upcomingPromotion',
				name: 'upcomingPromotion',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(908)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'configurationByTime',
				name: 'configurationByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(898)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemLinking',
				name: 'itemLinking',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(899)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemLinkingEdit',
				name: 'itemLinkingEdit',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(900)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productionSchedule',
				name: 'productionSchedule',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(905)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productScheduleAdd',
				name: 'productScheduleAdd',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(906)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'user',
				name: 'user',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(939)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'addUser',
				name: 'addUser',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(935)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'editUser',
				name: 'editUser',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(937)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'role',
				name: 'role',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(938)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'editRole',
				name: 'editRole',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(936)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'addRole',
				name: 'addRole',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(934)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'salesDataManage',
				name: 'salesDataManage',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(921)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'weeklyTotalItemMovementReport',
				name: 'weeklyTotalItemMovementReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(917)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemsWithoutSalesReport',
				name: 'itemsWithoutSalesReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(914)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'zeroBOHReport',
				name: 'zeroBOHReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(919)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'zeroBOHSummary',
				name: 'zeroBOHSummary',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(920)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'highBOHReport',
				name: 'highBOHReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(911)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'highDisplayStandardReport',
				name: 'highDisplayStandardReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(912)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'toolUsageReport',
				name: 'toolUsageReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(916)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'storeHeatMapReport',
				name: 'storeHeatMapReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(915)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemNoSalesZeroBOH',
				name: 'itemNoSalesZeroBOH',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(913)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'zeroBOHByWeekday',
				name: 'zeroBOHByWeekday',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(918)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'focusStore',
				name: 'focusStore',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(910)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'complianceReport',
				name: 'complianceReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(909)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}]
		}]
	});
	
	router.beforeEach(function (to, from, next) {
		if (to.matched.length === 0) {
			from.name ? next({
				name: from.name
			}) : next('/error404');
		} else {
			next();
		}
	});
	
	exports.default = router;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(993);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  state: {
	    showRegister: true
	  },
	  getters: {},
	  mutations: {
	    changeHeader: function changeHeader(state) {
	      if (state.showRegister) {
	        state.showRegister = false;
	      } else {
	        state.showRegister = true;
	      }
	    }
	  }
	});
	exports.default = store;

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 239,
		"./af.js": 239,
		"./ar": 247,
		"./ar-dz": 240,
		"./ar-dz.js": 240,
		"./ar-kw": 241,
		"./ar-kw.js": 241,
		"./ar-ly": 242,
		"./ar-ly.js": 242,
		"./ar-ma": 243,
		"./ar-ma.js": 243,
		"./ar-ps": 244,
		"./ar-ps.js": 244,
		"./ar-sa": 245,
		"./ar-sa.js": 245,
		"./ar-tn": 246,
		"./ar-tn.js": 246,
		"./ar.js": 247,
		"./az": 248,
		"./az.js": 248,
		"./be": 249,
		"./be.js": 249,
		"./bg": 250,
		"./bg.js": 250,
		"./bm": 251,
		"./bm.js": 251,
		"./bn": 253,
		"./bn-bd": 252,
		"./bn-bd.js": 252,
		"./bn.js": 253,
		"./bo": 254,
		"./bo.js": 254,
		"./br": 255,
		"./br.js": 255,
		"./bs": 256,
		"./bs.js": 256,
		"./ca": 257,
		"./ca.js": 257,
		"./cs": 258,
		"./cs.js": 258,
		"./cv": 259,
		"./cv.js": 259,
		"./cy": 260,
		"./cy.js": 260,
		"./da": 261,
		"./da.js": 261,
		"./de": 264,
		"./de-at": 262,
		"./de-at.js": 262,
		"./de-ch": 263,
		"./de-ch.js": 263,
		"./de.js": 264,
		"./dv": 265,
		"./dv.js": 265,
		"./el": 266,
		"./el.js": 266,
		"./en-au": 267,
		"./en-au.js": 267,
		"./en-ca": 268,
		"./en-ca.js": 268,
		"./en-gb": 269,
		"./en-gb.js": 269,
		"./en-ie": 270,
		"./en-ie.js": 270,
		"./en-il": 271,
		"./en-il.js": 271,
		"./en-in": 272,
		"./en-in.js": 272,
		"./en-nz": 273,
		"./en-nz.js": 273,
		"./en-sg": 274,
		"./en-sg.js": 274,
		"./eo": 275,
		"./eo.js": 275,
		"./es": 279,
		"./es-do": 276,
		"./es-do.js": 276,
		"./es-mx": 277,
		"./es-mx.js": 277,
		"./es-us": 278,
		"./es-us.js": 278,
		"./es.js": 279,
		"./et": 280,
		"./et.js": 280,
		"./eu": 281,
		"./eu.js": 281,
		"./fa": 282,
		"./fa.js": 282,
		"./fi": 283,
		"./fi.js": 283,
		"./fil": 284,
		"./fil.js": 284,
		"./fo": 285,
		"./fo.js": 285,
		"./fr": 288,
		"./fr-ca": 286,
		"./fr-ca.js": 286,
		"./fr-ch": 287,
		"./fr-ch.js": 287,
		"./fr.js": 288,
		"./fy": 289,
		"./fy.js": 289,
		"./ga": 290,
		"./ga.js": 290,
		"./gd": 291,
		"./gd.js": 291,
		"./gl": 292,
		"./gl.js": 292,
		"./gom-deva": 293,
		"./gom-deva.js": 293,
		"./gom-latn": 294,
		"./gom-latn.js": 294,
		"./gu": 295,
		"./gu.js": 295,
		"./he": 296,
		"./he.js": 296,
		"./hi": 297,
		"./hi.js": 297,
		"./hr": 298,
		"./hr.js": 298,
		"./hu": 299,
		"./hu.js": 299,
		"./hy-am": 300,
		"./hy-am.js": 300,
		"./id": 301,
		"./id.js": 301,
		"./is": 302,
		"./is.js": 302,
		"./it": 304,
		"./it-ch": 303,
		"./it-ch.js": 303,
		"./it.js": 304,
		"./ja": 305,
		"./ja.js": 305,
		"./jv": 306,
		"./jv.js": 306,
		"./ka": 307,
		"./ka.js": 307,
		"./kk": 308,
		"./kk.js": 308,
		"./km": 309,
		"./km.js": 309,
		"./kn": 310,
		"./kn.js": 310,
		"./ko": 311,
		"./ko.js": 311,
		"./ku": 313,
		"./ku-kmr": 312,
		"./ku-kmr.js": 312,
		"./ku.js": 313,
		"./ky": 314,
		"./ky.js": 314,
		"./lb": 315,
		"./lb.js": 315,
		"./lo": 316,
		"./lo.js": 316,
		"./lt": 317,
		"./lt.js": 317,
		"./lv": 318,
		"./lv.js": 318,
		"./me": 319,
		"./me.js": 319,
		"./mi": 320,
		"./mi.js": 320,
		"./mk": 321,
		"./mk.js": 321,
		"./ml": 322,
		"./ml.js": 322,
		"./mn": 323,
		"./mn.js": 323,
		"./mr": 324,
		"./mr.js": 324,
		"./ms": 326,
		"./ms-my": 325,
		"./ms-my.js": 325,
		"./ms.js": 326,
		"./mt": 327,
		"./mt.js": 327,
		"./my": 328,
		"./my.js": 328,
		"./nb": 329,
		"./nb.js": 329,
		"./ne": 330,
		"./ne.js": 330,
		"./nl": 332,
		"./nl-be": 331,
		"./nl-be.js": 331,
		"./nl.js": 332,
		"./nn": 333,
		"./nn.js": 333,
		"./oc-lnc": 334,
		"./oc-lnc.js": 334,
		"./pa-in": 335,
		"./pa-in.js": 335,
		"./pl": 336,
		"./pl.js": 336,
		"./pt": 338,
		"./pt-br": 337,
		"./pt-br.js": 337,
		"./pt.js": 338,
		"./ro": 339,
		"./ro.js": 339,
		"./ru": 340,
		"./ru.js": 340,
		"./sd": 341,
		"./sd.js": 341,
		"./se": 342,
		"./se.js": 342,
		"./si": 343,
		"./si.js": 343,
		"./sk": 344,
		"./sk.js": 344,
		"./sl": 345,
		"./sl.js": 345,
		"./sq": 346,
		"./sq.js": 346,
		"./sr": 348,
		"./sr-cyrl": 347,
		"./sr-cyrl.js": 347,
		"./sr.js": 348,
		"./ss": 349,
		"./ss.js": 349,
		"./sv": 350,
		"./sv.js": 350,
		"./sw": 351,
		"./sw.js": 351,
		"./ta": 352,
		"./ta.js": 352,
		"./te": 353,
		"./te.js": 353,
		"./tet": 354,
		"./tet.js": 354,
		"./tg": 355,
		"./tg.js": 355,
		"./th": 356,
		"./th.js": 356,
		"./tk": 357,
		"./tk.js": 357,
		"./tl-ph": 358,
		"./tl-ph.js": 358,
		"./tlh": 359,
		"./tlh.js": 359,
		"./tr": 360,
		"./tr.js": 360,
		"./tzl": 361,
		"./tzl.js": 361,
		"./tzm": 363,
		"./tzm-latn": 362,
		"./tzm-latn.js": 362,
		"./tzm.js": 363,
		"./ug-cn": 364,
		"./ug-cn.js": 364,
		"./uk": 365,
		"./uk.js": 365,
		"./ur": 366,
		"./ur.js": 366,
		"./uz": 368,
		"./uz-latn": 367,
		"./uz-latn.js": 367,
		"./uz.js": 368,
		"./vi": 369,
		"./vi.js": 369,
		"./x-pseudo": 370,
		"./x-pseudo.js": 370,
		"./yo": 371,
		"./yo.js": 371,
		"./zh-cn": 372,
		"./zh-cn.js": 372,
		"./zh-hk": 373,
		"./zh-hk.js": 373,
		"./zh-mo": 374,
		"./zh-mo.js": 374,
		"./zh-tw": 375,
		"./zh-tw.js": 375
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 881;


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(857)
	
	/* script */
	__vue_exports__ = __webpack_require__(420)
	
	/* template */
	var __vue_template__ = __webpack_require__(979)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(469)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	
	module.exports = __vue_exports__


/***/ }),

/***/ 979:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.53730f520a1edf5e7850.js